module.exports = __webpack_public_path__ + "img/ective_100Ah.2c81f966.png";